import PropTypes from "prop-types";
import React from "react";
import Spinner from "../Spinner";
import { cn } from "@/utils/cn";

function CustomHeaderActions({ actions }) {
  if (!actions || actions.length === 0) return null;

  return (
    <div className="flex gap-x-2">
      {actions.map((action, index) => (
        <button
          key={index}
          disabled={action.isLoading}
          onClick={action.onClick}
          className={cn(
            "h-8 min-w-[96px] px-[16px] flex items-center justify-center gap-x-2 font-extralight text-sm text-white hover:underline underline-offset-1 rounded-7 shadow-primary-inset disabled:opacity-70",
            action.className ?? "",
            action.backgroundColor ? `bg-${action.backgroundColor}` : "bg-gray-500",
            action.color ? `text-${action.color}` : "text-white",
          )}
        >
          {action.icon && (typeof action.icon === "function" ? action.icon() : React.createElement(action.icon, { size: 16 }))}
          <span>{action.label}</span>
          <span>{action.isLoading && <Spinner size="sm" />}</span>
        </button>
      ))}
    </div>
  );
}

CustomHeaderActions.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      icon: PropTypes.elementType,
      isLoading: PropTypes.bool,
      backgroundColor: PropTypes.string,
      color: PropTypes.string,
      className: PropTypes.string,
    })
  ).isRequired,
};

export default CustomHeaderActions;
